import { renderRouterLink } from '@/lib/render-link';
import { EmptyCard } from '@pms-digital/design-system';

/** "+" card in the company grid: the package's empty card, a link to the creation page. */
export function NewCompanyCard() {
  return (
    <EmptyCard
      tone="accent"
      icon="add"
      message="Nouvelle entreprise"
      href="/companies/new"
      renderLink={renderRouterLink}
    />
  );
}
